export const CONSTANTS = {
  applicationId: process.env.VUE_APP_APPLICATION_ID,
  restApiKey: process.env.VUE_APP_REST_API_KEY,
  apiEndPoint: process.env.VUE_APP_API_ENDPOINT,
  apiEndPoint2: process.env.VUE_APP_API_ENDPOINT_V2,
  liveQueryEndPoint: process.env.VUE_APP_LIVEQUERY_ENDPOINT,
  smsShortLinkPrefix: process.env.VUE_APP_SMS_SHORTLINK_PREFIX,
  intercomAppId: process.env.VUE_APP_INTERCOM_APP_ID,
  intercomHashSecret: process.env.VUE_APP_INTERCOM_HASH_SECRET,
};
